import { useMemo } from 'react'
import { splitHighlightedSnippet } from './docsSearchUtils'

type DocsSearchResultSnippetProps = {
  snippet: string
  query: string
}

export function DocsSearchResultSnippet({ snippet, query }: DocsSearchResultSnippetProps) {
  const parts = useMemo(() => splitHighlightedSnippet(snippet, query), [snippet, query])

  return (
    <span className="docs-search-result-snippet">
      {parts.map((part, index) =>
        part.highlight ? <mark key={index}>{part.text}</mark> : <span key={index}>{part.text}</span>,
      )}
    </span>
  )
}
